export const FirebaseConfig = {
	"projectId": "pickappstaging",
	"appId": "1:718916592721:web:d3f248caf755af042d8470",
	"databaseURL": "https://pickappstaging-default-rtdb.firebaseio.com",
	"storageBucket": "pickappstaging.firebasestorage.app",
	"apiKey": "AIzaSyC6TBS3BA-D2CQJMIiyGh9S_z2A2NHK5Hk",
	"authDomain": "pickappstaging.firebaseapp.com",
	"messagingSenderId": "718916592721",
	"measurementId": "G-4T368SF908"
};